import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { apiFetch } from "../lib/api";
import SEO from "../components/SEO.jsx";
import { seoPresets } from "../seoPresets";


export default function ResetPassword() {
  const seo = seoPresets["/reset-password"];
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = params.get("token");

  async function submit(e) {
    e.preventDefault();
    setErr("");
    if (!token) return setErr("Missing reset token.");
    setLoading(true);
    try {
      await apiFetch("/api/auth/set-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password, token }),
      });
      setOk(true);
    } catch (e) {
      setErr(e.message || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
    <SEO
        title={seo.title}
        description={seo.description}
        canonical={seo.canonical}
        image={seo.openGraph?.image}
        jsonLd={seo.jsonLd}
        ogType={seo.openGraph?.type || "website"}
        twitterCard={seo.twitter?.card || "summary_large_image"}
        robots="noindex, nofollow"
      />
    <div className="auth-wrap">
      <style>{css}</style>
      <div className="auth-card">
        {ok ? (
          <>
            <h2>Password changed!</h2>
            <p>You can now log in with your new password.</p>
            <button className="btn" onClick={() => navigate("/login")}>
              Go to Login
            </button>
          </>
        ) : (
          <>
            <h2>Reset password</h2>
            <form onSubmit={submit}>
              <input
                type="password"
                placeholder="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {err && <div className="error">{err}</div>}
              <button className="btn primary" disabled={loading}>
                {loading ? "Saving…" : "Set new password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
    </>
  );
}

const css = `
.auth-wrap {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: #f7f9fc;
}
.auth-card {
  background: #fff;
  padding: 28px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,.08);
  width: 100%;
  max-width: 420px;
  text-align: center;
}
input {
  width: 100%;
  padding: 12px;
  border: 1px solid #d6d9e0;
  border-radius: 10px;
  margin-bottom: 14px;
  font-size: 15px;
}
input:focus {
  outline: none;
  border-color: #6E5BFF;
  box-shadow: 0 0 0 4px rgba(110,91,255,.15);
}
.error {
  color: #b91c1c;
  font-size: 13px;
  margin-bottom: 8px;
}
.btn {
  border: none;
  background: linear-gradient(90deg,#6E5BFF,#A78BFA);
  color: #fff;
  padding: 12px 16px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
}
`;
